import { useQuery } from "@tanstack/react-query";
import carouselApi, { CAROUSEL_KEY } from "../../api/carouselApi";

export const useGetCarouselHomepage = () => {
    return useQuery({
        queryKey: CAROUSEL_KEY,
        queryFn: async () => {
            const res = await carouselApi.getCarousel();
            const data = res.data?.data ?? res.data;
            return data ?? null;
        },
    });
};